import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, BarChart3, RefreshCw } from 'lucide-react';

export default function RedirectScreen({ onRestart }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Header */}
      <header className="w-full border-b border-border bg-background">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <BarChart3 className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-semibold text-foreground">Diagnostic Pro</span>
        </div>
      </header>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-xl w-full animate-fade-in">
          <Card className="border-border shadow-lg">
            <CardContent className="p-8 sm:p-10">
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-primary-muted flex items-center justify-center mb-6">
                <BarChart3 className="w-8 h-8 text-primary" />
              </div>

              {/* Title */}
              <h1 className="text-2xl sm:text-3xl font-semibold text-foreground mb-4">
                Audit Structure recommandé
              </h1>

              {/* Description */}
              <div className="space-y-4 text-muted-foreground mb-8">
                <p>
                  Au vu de ton volume d&apos;activité et de ton chiffre d&apos;affaires, le diagnostic Starter ne serait pas adapté à tes enjeux actuels.
                </p>
                <p>
                  Pour une analyse pertinente de ta situation, nous te recommandons l&apos;<span className="text-foreground font-medium">Audit Structure</span>, conçu pour les activités plus développées.
                </p>
                <p className="text-sm border-l-2 border-primary pl-4 py-2 bg-primary-muted/50 rounded-r-md">
                  Ce n&apos;est pas une question de niveau, mais de pertinence. Un diagnostic adapté à ta réalité te sera bien plus utile.
                </p>
              </div>

              {/* Actions */}
              <div className="space-y-3">
                <Button
                  className="w-full gap-2"
                  size="lg"
                  onClick={() => {
                    window.location.href = 'https://diagnostic.blackcore-ai.com/';                    
                  }}
                >
                  Accéder à l&apos;Audit Structure
                  <ArrowRight className="w-5 h-5" />
                </Button>
                
                <Button
                  variant="ghost"
                  className="w-full gap-2"
                  onClick={onRestart}
                >
                  <RefreshCw className="w-4 h-4" />
                  Recommencer le diagnostic
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}